import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";

import DemoForm from "./DemoForm";
import AutoBindComponent from "../../common/AutoBindComponent";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import DemoPageHelper from "./DemoPageHelper";

class DemoPage extends AutoBindComponent {
    constructor(props, context) {
        super(props, context, true);

        this.filesHelper = null;
        this.state = {
            model: null,
            errors: null,
            hasUnsavedChanges: false
        };

        this.pageHelper = new DemoPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount(); // better way to handle unsaved changes
        this.pageHelper.init();
    };

    handleOnUploadFiles = (component, files) => this.filesHelper.uploadFiles(component, files);
    handleOnDeleteFile = (component, file) => this.filesHelper.deleteOneFile(component, file);
    handleOnSave = () => this.pageHelper.save();
    handleOnChange = (event) => this.pageHelper.change(event);
    handleOnClose = () => this.pageHelper.close();
    isReadyToRender = () => {
        return this.state.model;
        //&& this.state.fileComponents;
    };

    render() {
        if (!this.isReadyToRender())
            return null;

        const model = this.state.model;

        return (
            <Fragment>
                <Section title={"Demo"}>
                    <DemoForm
                        model={model}
                        onChange={this.handleOnChange}
                        onSave={this.handleOnSave}
                        onClose={this.handleOnClose}
                        fileComponents={{}}
                        onUploadFiles={this.handleOnUploadFiles}
                        onDeleteFile={this.handleOnDeleteFile}
                        fileDownloadUrl=""//{this.filesHelper.getFileDownloadUrl()}
                        templateDownloadUrl=""//{this.filesHelper.getTemplateDownloadUrl()}
                        errors={this.state.errors}
                        disabled={false}
                        readonly={false}
                    />
                </Section>
            </Fragment>);
    }
}

DemoPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state, ownProps) {
    return {
        //get ref data
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadDemoPageLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DemoPage);